import { render, staticRenderFns } from "./BundleSEOSettings.vue?vue&type=template&id=31de214f&"
import script from "./BundleSEOSettings.vue?vue&type=script&lang=js&"
export * from "./BundleSEOSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports